<app-base-modal
  [title]="'Добавить группу'"
>
  <div class="container">
    <mat-tab-group (selectedTabChange)="handleTabChange($event)">
      <mat-tab label="Создать новую">
        <div class="content">
          <mat-form-field
            appearance="outline"
            class="form-field"
          >
            <mat-label>Название группы</mat-label>
            <input
              matInput
              type="text"
              required
              [(ngModel)]="groupName"
            >
          </mat-form-field>
        </div>
      </mat-tab>
        <mat-tab
          [label]="getAttachTabLabel()"
          [disabled]="!bloggerGroups.length"
        >
          <div class="content">
            <mat-form-field
              appearance="outline"
              class="form-field"
            >
              <input
                matInput
                placeholder="Поиск по названию"
                [(ngModel)]="searchBloggerGroupName"
                (ngModelChange)="loadBloggerGroups()">
              <mat-label>Поиск группы</mat-label>
            </mat-form-field>
            <div class="blogger-form-list">
              <mat-selection-list
                [multiple]="false"
                [(ngModel)]="selectedBloggerGroup"
              >
                @for (bloggerGroup of bloggerGroups; track $index) {
                  <mat-list-option [value]="bloggerGroup">
                    {{ bloggerGroup.name }}
                  </mat-list-option>
                }
              </mat-selection-list>
            </div>
          </div>
        </mat-tab>
    </mat-tab-group>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      class="save-button"
      [disabled]="isDisabled()"
      (click)="handleClick()"
    >
      {{ getTextBtn() }}
    </button>
    <button
      mat-button
      color="primary"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
